import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionLabel } from "@/components/Section";

export default function CtaBanner({
  eyebrow = "Ready to scale?",
  title = "Ready to expand your quick commerce operations?",
  cta = "Partner With OneHill",
  to = "/contact",
}) {
  return (
    <section data-testid="cta-banner" className="bg-[#F7F8F5] px-5 py-20 lg:py-24">
      <div className="mx-auto max-w-7xl">
        <div className="relative overflow-hidden rounded-[2rem] bg-[#1F1F1F] text-white p-10 lg:p-14">
          <div
            className="absolute inset-0 opacity-60"
            style={{ background: "radial-gradient(circle at 90% 20%, rgba(153,204,0,0.28), transparent 35%)" }}
          />
          <div className="relative flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div>
              <SectionLabel>{eyebrow}</SectionLabel>
              <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-display font-black tracking-tight leading-[1.05] max-w-3xl">
                {title}
              </h2>
            </div>
            <Link
              to={to}
              data-testid="cta-banner-link"
              className="inline-flex items-center gap-2 rounded-full bg-[#99CC00] text-[#1F1F1F] px-7 py-4 text-sm font-black hover:bg-[#B5E000] transition-colors whitespace-nowrap"
            >
              {cta} <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
